import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as brokerHooks from "@rentiohq/shared-frontend/dist/redux/broker/broker.hooks";
import { EBrokerFeature } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { getCostsVisibility, ICostsVisibility } from "./costsVisibility.utils";

// The one place that decides whether a costs & settlements screen shows: the
// office's COSTS_AND_SETTLEMENTS feature (see costsVisibility.utils).
export const useCostsVisibility = (): ICostsVisibility => {
  const { user } = authHooks.useSelf();
  const { isFetchingBroker, hasFeature } = brokerHooks.useBrokerFeatureLoader(
    EBrokerFeature.CostsAndSettlements,
  );

  return getCostsVisibility({
    hasOfficeFeature: hasFeature,
    // Before the user is known, the office is not known either.
    isFetchingOffice: !user || isFetchingBroker,
  });
};

// The costs, the settlements and their drawers.
export const useCostsEnabled = () => useCostsVisibility().isEnabled;

// The apportionment keys tab of a building: the same office feature, on
// purpose (Lewis, 2026-10-28). The keys only serve to split costs, so an
// office gets them together with the costs and never one without the other;
// before, a separate global flag for the keys could hold the tab back.
export const useApportionmentKeysEnabled = useCostsEnabled;
